var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("合并单信息")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "shrink-tab fr",
            class: _vm.showFormInfoFlag ? "current" : "",
            on: {
              click: function($event) {
                _vm.doShowFormInfo()
              }
            }
          },
          [
            _c("span", [
              _vm._v(_vm._s(_vm.showFormInfoFlag ? "隐藏" : "展开"))
            ]),
            _vm._v(" "),
            _c("i", {
              class: _vm.showFormInfoFlag
                ? "el-icon-arrow-down"
                : "el-icon-arrow-right"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _vm.showFormInfoFlag
        ? [
            _c("div", { staticClass: "simple-form flex col-3" }, [
              _c("div", { staticClass: "form-group" }, [
                _vm._m(0),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.formInfo.retailerComFullName || "无"))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(1),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.formInfo.title || "无"))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(2),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.formInfo.innerNo || "无"))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(3),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s(_vm.mergeWayMap[_vm.formInfo.mergeWay]))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(4),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.formInfo.mergeDesc || ""))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(5),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(
                      _vm._s(
                        parseFloat(_vm.formInfo.mergedAmount || 0).toFixed(2)
                      )
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(6),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm.formInfo.devcInnerCode != null &&
                    _vm.formInfo.devcInnerCode != ""
                      ? _c(
                          "a",
                          {
                            staticClass: "table-cell-link",
                            on: {
                              click: function($event) {
                                _vm.viewAssetInfo(_vm.formInfo)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.formInfo.devcInnerCode))]
                        )
                      : _vm._e()
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(7),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.formInfo.devcNo || ""))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(8),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [
                    _vm._v(_vm._s((_vm.formInfo.orgWorth || 0).toFixed(2)))
                  ])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(9),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.formInfo.theQuantity))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(10),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.formInfo.createTime))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(11),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _vm.formInfo.applyState == 0
                    ? _c("span", [_vm._v("待申请")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.formInfo.applyState == 1 && _vm.formInfo.auditState == 0
                    ? _c("span", [_vm._v("待审核")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.formInfo.auditState == 1
                    ? _c("span", [_vm._v("审核通过")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.formInfo.auditState == -1
                    ? _c("span", [_vm._v("审核未通过")])
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(12),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.formInfo.auditorName || ""))])
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(13),
                _vm._v(" "),
                _c("div", { staticClass: "form-value" }, [
                  _c("span", [_vm._v(_vm._s(_vm.formInfo.auditDesc))])
                ])
              ])
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "content-caption dashed" }, [
        _c("span", [_vm._v("新资产信息")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "shrink-tab fr",
            class: _vm.showItemFlag ? "current" : "",
            on: {
              click: function($event) {
                _vm.doShowItem()
              }
            }
          },
          [
            _c("span", [_vm._v(_vm._s(_vm.showItemFlag ? "隐藏" : "展开"))]),
            _vm._v(" "),
            _c("i", {
              class: _vm.showItemFlag
                ? "el-icon-arrow-down"
                : "el-icon-arrow-right"
            })
          ]
        )
      ]),
      _vm._v(" "),
      _vm.showItemFlag
        ? [
            _vm.formInfo.itemList != null && _vm.formInfo.itemList.length > 0
              ? _c(
                  "div",
                  { staticClass: "table-layout" },
                  [
                    _c(
                      "el-table",
                      {
                        ref: "dataTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          data: _vm.formInfo.itemList,
                          border: "",
                          maxHeight: "400",
                          "tooltip-effect": "dark",
                          "summary-method": _vm.getItemAmountSum,
                          "show-summary": ""
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            prop: "devcInnerCode",
                            label: "资产编号",
                            width: "160",
                            fixed: "",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.devcInnerCode != null &&
                                  rows.row.devcInnerCode != ""
                                    ? _c(
                                        "a",
                                        {
                                          staticClass: "table-cell-link",
                                          on: {
                                            click: function($event) {
                                              _vm.viewAssetInfo(rows.row)
                                            }
                                          }
                                        },
                                        [_vm._v(_vm._s(rows.row.devcInnerCode))]
                                      )
                                    : _c("span", [
                                        _vm._v(_vm._s(rows.row.devcInnerCode))
                                      ])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            prop: "title",
                            label: "资产描述全称",
                            width: "200",
                            fixed: "",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            prop: "modelSpec",
                            label: "型号规格",
                            width: "120",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "right",
                            prop: "theQuantity",
                            label: "数量",
                            width: "100",
                            "show-overflow-tooltip": ""
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "right",
                            prop: "orgWorth",
                            label: "原值(元)",
                            width: "150",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.orgWorth != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(rows.row.orgWorth.toFixed(2))
                                        )
                                      ])
                                    : _c("span", [_vm._v("0.00")])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "right",
                            prop: "aggtDeprWorth",
                            label: "累计折旧(元)",
                            width: "150",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.aggtDeprWorth != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            rows.row.aggtDeprWorth.toFixed(2)
                                          )
                                        )
                                      ])
                                    : _c("span", [_vm._v("0.00")])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "right",
                            prop: "netWorth",
                            label: "净值(元)",
                            width: "150",
                            "show-overflow-tooltip": ""
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  rows.row.netWorth != null
                                    ? _c("span", [
                                        _vm._v(
                                          _vm._s(rows.row.netWorth.toFixed(2))
                                        )
                                      ])
                                    : _c("span", [_vm._v("0.00")])
                                ]
                              }
                            }
                          ])
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "left",
                            prop: "retailerComFullName",
                            label: "所属部门",
                            "show-overflow-tooltip": ""
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e()
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("机构名称")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("标题")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("合并单号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("合并方式")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("合并原因")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("合并后原值(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("资产编号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("系统编号")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("资产原值(元)")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("资产数量")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("单据创建时间")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("状态")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("审核人")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", [_vm._v("审核描述")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-378bbd7b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-378bbd7b","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/devcMerge/DevcMergeFormDetail.vue
// module id = 2645
// module chunks = 0